import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { fetchJson } from '@/lib/api';

export const useEnhanceResume = () => {
  const { push } = useToast();

  return useMutation({
    mutationFn: (data: {
      answers?: {
        answer: string;
        question: string;
      }[];
      resumeText: string;
    }) =>
      fetchJson<{
        resume_md?: string;
        questions?: {
          context: string;
          id: string;
          question: string;
        }[];
      }>('/api/profile/enhance', {
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
      }),
    onError: (error: Error) =>
      push(error.message || 'Resume enhancement failed', 'error'),
  });
};
